// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PLAN_MEDIUM_SAFETY_UPLOADING_CHOOSE,
} from './constants';

export function mediumSafetyUploadingChoose(visible,id) {
  return {
    type: PLAN_MEDIUM_SAFETY_UPLOADING_CHOOSE,
    data:{visible,id}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_MEDIUM_SAFETY_UPLOADING_CHOOSE:
      return {
        ...state,
        mediumSafetyUploadingVisible:action.data.visible,
        mediumSafetyUploadingId:action.data.id
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/mediumSafetyUploadingChoose.js